import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function List($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M3 5h.01" }],
		["path", { "d": "M3 12h.01" }],
		["path", { "d": "M3 19h.01" }],
		["path", { "d": "M8 5h13" }],
		["path", { "d": "M8 12h13" }],
		["path", { "d": "M8 19h13" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiTGlzdC5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJNMyA1aC4wMVwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTMgMTJoLjAxXCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJNMyAxOWguMDFcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk04IDVoMTNcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk04IDEyaDEzXCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJNOCAxOWgxM1wiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7Z0RBRGxDLENBQUM7T0FFTyxRQUE0QztHQUFLLE1BQU0sSUFBSSxHQUFHLEVBQUUsVUFBVTtHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsV0FBVztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsV0FBVztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsU0FBUztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsVUFBVTtHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsVUFBVTs7O0tBQ3hPLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9